import HeroLeftImage from 'app/assets/images/help-center/help-center-hero-left.png'
import HeroRightImage from 'app/assets/images/help-center/help-center-hero-right.png'
import Stack from 'app/components/base/Stack'

import HeroImage from './HeroImage'
import HeroTextBlock from './HeroTextBlock'

const HeroSection = () => {
  return (
    <Stack
      direction="row"
      sx={{
        position: 'relative',
        mt: 4.75,
        justifyContent: { xs: 'center', lg: 'space-between' },
        px: { xs: 2, md: 0 },
        height: { md: 240, lg: 'auto' },
        overflowX: 'hidden'
      }}
    >
      <HeroImage
        image={HeroLeftImage}
        alt="hero-left"
        sx={{ left: { md: -170, lg: 0 } }}
      />

      <HeroTextBlock />

      <HeroImage
        image={HeroRightImage}
        alt="hero-right"
        sx={{ right: { md: -170, lg: 0 } }}
      />
    </Stack>
  )
}

export default HeroSection
